<div
  class="banner"
  [ngStyle]="{
    'background-color': backgroundColour ? '#' + backgroundColour : null
  }"
>
  <div class="banner-wrapper">
    <div class="banner-heading">
      <i
        class="fa fa-info-circle infoIcon"
        [ngStyle]="{ color: textColour ? '#' + textColour : null }"
        aria-hidden="true"
      ></i>
      <h2 [ngStyle]="{ color: textColour ? '#' + textColour : null }">
        {{ title | i18next }}
      </h2>
    </div>
    <p [ngStyle]="{ color: textColour ? '#' + textColour : null }">
      {{ text | i18next }}
    </p>
    <p *ngIf="link">
      <a
        [href]="link.link"
        [ngStyle]="{ color: textColour ? '#' + textColour : null }"
        [target]="link.newWindow ? '_blank' : '_self'"
        >{{ link.caption }}
      </a>
    </p>
    <button
      aria-label="Close banner"
      (click)="handleCloseBanner()"
      class="closeButton"
    >
      <i
        class="fa fa-times"
        [ngStyle]="{ color: textColour ? '#' + textColour : null }"
        aria-hidden="true"
      ></i>
    </button>
  </div>
</div>
